const aux = props => props.children;

export default aux;


// WEBPACK FOOTER //
// ./src/containers/hoc/Auxiliary.js